import data from "../../../../../src/AvatarPair/AvatarPair.docs.json";
import * as React from 'react';
export default {
  data,
  React
};